import React, { useContext } from 'react';
import { CardActions, CardContent, Divider, CardHeader, Tooltip } from '@mui/material';
import EyeBrow from '../../commonComponents/eyeBrow/eyeBrow'
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { ThemeContext } from 'styled-components';
import HyperLink from "../../commonComponents/hyperLink/hyperLink";
import { DeviceCardStyle, CardStyle } from './deviceCard.style'
import { StyledTooltip } from '../pcCard/pcCard.style';
import Typography from 'component/MarketPlace/Typography';
import { TruncatedText } from 'component/MarketPlace/Typography/Typography.style';
import UptimeImage from 'component/commonComponents/UptimeImage/UptimeImage';
import { generateImgUrl } from 'utils/functions';

export interface IDeviceCardProps {
  refreshInfo: string;
  returnInfo: string;
  getInfoUrl: any;
  onActionClick: any;
  infoDevice: any;
  backgroundImg: string;
  defaultImage: string;
  locale: {
    actionName: {
      refresh: string;
      preparingDevice: string;
      deviceInTransit: string;
      pcReturn: string;
      preparingShippingMaterials: string;
      awaitingApproval: string;
    },
    warningText: {
      refresh: string;
      preparingDevice: string;
      deviceInTransit: string;
      pcReturn: string;
      preparingShippingMaterials: string;
      awaitingApproval: string;
    },
    infoText: {
      pcReturn: string;
      preparingShippingMaterials: string;
      moreInfo: string;
    },
    commonStatus: any,
    serialNumber: string,
  }
};

const DeviceCard = (props: IDeviceCardProps) => {
  const {
    refreshInfo,
    returnInfo,
    getInfoUrl,
    onActionClick,
    infoDevice,
    backgroundImg,
    defaultImage,
    locale
  } = props;

  const { new_asset } = infoDevice.process_stage;
  const theme = useContext(ThemeContext);
  let actionNameList : any = null;
  let warningTextList : any = null;
  let infoTextList : any = null;
  let commonStatusList : any = null;
  if (locale) {
    const { actionName, warningText, infoText, commonStatus } = locale;
    actionNameList = actionName;
    warningTextList = warningText;
    infoTextList = infoText;
    commonStatusList = commonStatus;
  }

  let actionName = '';
  let infoLink = refreshInfo;
  let infoText = infoTextList?.moreInfo;
  let warningText = '';
  let colorEyeBrow = theme.uptimeColors.deviceCardEyebrow.deviceCard.color;
  let backgroundColorEyeBrow = theme.uptimeColors.deviceCardEyebrow.deviceCard.background;
  let manufacturer = infoDevice.manufacturer;
  let model = infoDevice.model;
  let image = infoDevice.model_picture;
  let serialNumber = infoDevice.serial_number;

  const refStatus = {
    REFRESH: 'ELIGIBLE_FOR_REFRESH',
    PREPARING_DEVICE: 'PREPARING_DEVICE',
    DEVICE_IN_TRANSIT: 'DEVICE_IN_TRANSIT',
    PC_RETURN: 'PC_RETURN',
    PREPARING_SHIPPING_MATERIALS: 'PREPARING_SHIPPING_MATERIALS',
    AWAITING_APPROVAL: 'AWAITING_APPROVAL',
  };

  const generateDeviceCard = () => {
    switch (infoDevice.process_stage.stage) {
      case refStatus.REFRESH:
        actionName = actionNameList?.refresh;
        warningText = warningTextList?.refresh;
        break;
      case refStatus.PREPARING_DEVICE:
        model = new_asset?.model ? new_asset.model : '';
        manufacturer = new_asset?.manufacturer ? new_asset.manufacturer : '';
        image = new_asset?.model_picture ? new_asset.model_picture : defaultImage;
        actionName = actionNameList?.preparingDevice;
        serialNumber = '';
        warningText = warningTextList?.preparingDevice;
        break;
      case refStatus.DEVICE_IN_TRANSIT:
        model = new_asset?.model ?? '';
        manufacturer = new_asset?.manufacturer ?? '';
        image = new_asset?.model_picture || defaultImage;
        actionName = actionNameList?.deviceInTransit;
        serialNumber = '';
        warningText = warningTextList?.deviceInTransit;
        break;
      case refStatus.PC_RETURN:
        actionName = actionNameList?.pcReturn;
        infoLink = returnInfo;
        infoText = infoTextList?.pcReturn;
        warningText = warningTextList?.pcReturn;
        break;
      case refStatus.PREPARING_SHIPPING_MATERIALS:
        actionName = actionNameList?.preparingShippingMaterials;
        infoLink = returnInfo;
        infoText = infoTextList?.preparingShippingMaterials;
        warningText = warningTextList?.preparingShippingMaterials;
        break;
      case refStatus.AWAITING_APPROVAL:
        model = new_asset?.model ? new_asset.model : '';
        manufacturer = new_asset?.manufacturer ? new_asset.manufacturer : '';
        image = new_asset?.model_picture ? new_asset.model_picture : defaultImage;
        actionName = actionNameList?.awaitingApproval;
        serialNumber = '';
        warningText = warningTextList?.awaitingApproval;
        break;
      default:
        break;
    }
  };

  generateDeviceCard();

  const hasEyebrow = !!infoDevice.process_stage.task_eyebrow ? true : false;

  const clearSelection = () => {
    const selection = window.getSelection();
    if (selection) {
      selection.empty();
    }
  };

  return (
      <DeviceCardStyle onDragStart={clearSelection}  data-device_sn={infoDevice.serial_number} id="crd-devicecard-container" >
        <CardStyle>
          <CardHeader 
            className="device-card-header" 
            title={hasEyebrow 
            && <EyeBrow 
                color={colorEyeBrow} 
                backgroundColor={backgroundColorEyeBrow} 
                text={commonStatusList?.[infoDevice.process_stage.task_eyebrow?.toUpperCase()]} 
                id="crd-devicecard-header" 
              />}
          />
          <CardContent className="device-card-content">
            <UptimeImage
              src={image}
              alt="stuff_card"
              title={`${model} ${manufacturer} ${serialNumber}`}
              width="100%"
              height="80%"
              style={{ objectFit: "contain", aspectRatio: "1" }}
              wrapperProps={{
                style: {
                  flexShrink: 0,
                  width: "100%",
                  height: "113px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: 0,
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  backgroundImage: `url(${generateImgUrl(backgroundImg)})`,
                },
            }}/>
            <div className="my-stuff-card-body">
              <p className="my-stuff-card-body-type" id="lbl-devicecard-manufacturer" >{manufacturer}</p>
                { model &&
                  <Tooltip title={model} arrow placement="top-start">
                    <h5 className="my-stuff-card-body-name select-all-text" id="lbl-devicecard-model" >{model}</h5>
                  </Tooltip>
                }
              {serialNumber &&
                <div className="my-stuff-card-configuration-item" >
                  <LocalOfferIcon />
                  <Typography variant="body2" fontWeight={700} mr="8px" flexShrink={0} id="lbl-pccard-label">
                    {locale?.serialNumber}
                  </Typography>
                  <StyledTooltip title={serialNumber} arrow>
                    <TruncatedText maxlines={1} variant="body2" className="my-stuff-card-configuration-item-content select-all-text" title={serialNumber} id="lbl-devicecard-serial_number">
                      {serialNumber}
                    </TruncatedText>
                  </StyledTooltip>
                </div>
              }
              <Tooltip title={warningText} arrow placement="bottom-start">
                <div className="my-stuff-card-body-status select-all-text" id="lbl-devicecard-warning_text" >{warningText}</div>
              </Tooltip>
            </div>
          </CardContent>
          <CardActions className="device-card-footer">
            {[refStatus.PREPARING_DEVICE, refStatus.DEVICE_IN_TRANSIT, refStatus.AWAITING_APPROVAL].includes(infoDevice.process_stage.stage) && ['pc_breakfix', 'pc_lost_stolen', 'new_device'].includes(infoDevice.process_stage?.request_type) ? null :
              <>
                <HyperLink
                  className="my-stuff-card-link-text"
                  label={infoText}
                  onClick={() => getInfoUrl(infoLink)}
                  id="lnk-devicecard-info_link" 
                />
                <Divider className="my-stuff-divider-bar" orientation="vertical" flexItem />
              </>
            }
            <HyperLink
              className="my-stuff-card-link-text"
              label={actionName}
              onClick={onActionClick}
              id="lnk-devicecard-track"
            />
          </CardActions>
        </CardStyle>
      </DeviceCardStyle>

  );
};

export default DeviceCard;
